import LANGUAGE_NAMES from '../../../../lang/languages.json';
/**
 * Arabic UI is deferred until its planned integration. Keep its source files
 * and interpretation/transcription language contracts independent of this list.
 */
export function resolveUiLanguage(language) {
    // Accept both BCP-47 locales and the detector's compact region form (arSA).
    return /^ar(?:$|[-_]|[a-z]{2}$)/i.test(language) ? 'en' : language;
}
export const UI_LANGUAGES = Object.keys(LANGUAGE_NAMES)
    .filter(language => resolveUiLanguage(language) === language);
